import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NotStartedWithSpace(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const REGEXP = /^(?!\s)/;
    const isValid = REGEXP.test(control.value);
    return isValid ? null : { 'whitespace': 'value is started with space' };
  };
}
